<template>
	<div class="xs-12">
		<div class="flex xs-12 xs-middle p2 bb1 bc7">
			<!-- If permission is selected, show remove buttons -->
			<template v-if="isSelected">
				<j-button
					size="xsmall"
					type="error"
					@click="$emit('remove', { id: id, targetType: targetType })"
				>
					{{
						targetType === "all"
							? $t("remove_for_all")
							: $t("remove_for_creator")
					}}
				</j-button>
			</template>

			<!-- If permission not selected, show add buttons -->
			<template v-else>
				<j-button
					type="primary"
					size="xsmall"
					class="mr2"
					@click="$emit('add', { id: id, targetType: 'all' })"
				>
					{{ $t("add_for_all") }}
				</j-button>
				<j-button
					type="primary"
					size="xsmall"
					@click="$emit('add', { id: id, targetType: 'creator' })"
				>
					{{ $t("add_for_creator") }}
				</j-button>
			</template>

			<div class="flex wrap xs-middle ml2">
				<div class="xs-12 lh125 fw7">
					{{ name ? name : id }}
				</div>
				<div class="xs-12 c6 lh125">
					{{ description }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import JButton from "@/components/JButton"

export default {
	components: { JButton },

	props: {
		id: String,
		name: String,
		description: String,
		isSelected: Boolean,
		targetType: {
			validator(val) {
				return val === null || val === "all" || val === "creator"
			}
		}
	}
}
</script>
